import { Spinner } from 'react-bootstrap'

const Loading = (props) => {

    return <div className='flex-grow-1 d-flex align-items-center justify-content-center'><Spinner {...props} /></div>
    
}

export default Loading